import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import styles from './Modal.module.css';
import { useModalStore } from '../../store/ModalStore';
import { useTasksStore } from '../../store/TasksStore';

interface ModalProps {
  children: React.ReactNode;
  onClose?: () => void;
  noTopPadding?: boolean;
  noCloseButton?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  children,
  noTopPadding,
  noCloseButton,
}) => {
  const open = useModalStore((state) => state.open);
  const closing = useModalStore((state) => state.closing);
  const setOpen = useModalStore((state) => state.setOpen);
  const setClosing = useModalStore((state) => state.setClosing);
  const [isVisible, setIsVisible] = useState(false);
  const showDelayedNotification = useTasksStore(
    (state) => state.showDelayedNotification,
  );

  useEffect(() => {
    // if (open === true || open === 'boost' || open === 'dailyReward') {
    //   setIsVisible(true);
    // }
    if (open) {
      setIsVisible(true);
    }
  }, [open]);

  useEffect(() => {
    if (closing) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        setOpen(false);
        setClosing(false);

        // Показываем отложенные уведомления после закрытия модалки
        if (open === 'dailyReward') {
          setTimeout(() => {
            showDelayedNotification();
          }, 100);
        }
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [closing, setOpen, setClosing, open, showDelayedNotification]);

  useEffect(() => {
    if (isVisible) {
      // Блокируем прокрутку страницы
      document.body.style.overflow = 'hidden';
    } else {
      // Возвращаем возможность прокрутки
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isVisible]);

  const handleClose = () => {
    setClosing(true);
  };

  // Если модалка не видима - не рендерим ничего
  if (!isVisible) {
    return null;
  }

  const modalContainer = `${styles.modal} ${closing ? styles.slideDown : ''}`;

  const modalContent = (
    <div className={`${styles.modalWrapper} ${closing ? styles.closing : ''}`}>
      <div className={modalContainer} data-modal={open}>
        <div
          className={
            noTopPadding ? styles.modalContentNoTopPadding : styles.modalContent
          }
        >
          {!noCloseButton && (
            <button
              className={styles.closeButton}
              onClick={handleClose}
            ></button>
          )}
          {children}
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default Modal;
